import PropTypes from 'prop-types';
import { Tooltip } from 'react-tooltip';
import { PUNCTUATION } from '../../../../utils/constants/notation';
import { resolveFinancialSource, dataSourceClass } from '../../../../utils/constants/dataSources';
import { formatNumber } from '../../../../utils/utils';

/**
 * SummaryEmployeesRow
 *
 * Number of employees row for the General tab Summary card: renders either a
 * multi-year array table or a single value (with self-disclosure/basic styling
 * and tooltip). Receives `canViewExtendedData` to toggle the `last` class when
 * the Top mgmt. row is absent.
 *
 * @param {Object} props
 * @param {Object} props.company - Company data object
 * @param {boolean} props.canViewExtendedData - Whether user can view extended profiler data
 */
const SummaryEmployeesRow = ({ company = {}, canViewExtendedData = true }) => {
  return (
    <div className={`card-row${canViewExtendedData ? '' : ' last'}`}>
      <div
        className={`property ${company.employeesArray?.length ? 'number-of-employees' : ''} ${dataSourceClass(
          resolveFinancialSource({ isBasic: company.isEmployeesBasic })
        )}`}
      >
        Employees
      </div>
      {company.employeesArray?.length ? (
        <table className="employees-array-wrap">
          <tbody>
            {company.employeesArray.map((entry, idx) => {
              return (
                <tr key={entry.id || idx}>
                  <td>
                    <div className="number">{formatNumber(entry.value?.toFixed?.(2))}</div>
                    <div className="number-details">
                      <div>&lsquo;{entry.shortYear}</div>
                    </div>
                  </td>
                  <td>{entry.information_scope || PUNCTUATION.EMPTY_VALUE}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      ) : (
        <div className="value revenue">
          {!Number.isNaN(Number(company.employees)) && company.employees !== null ? (
            <>
              <font
                id={'employees-company-details-general-tab-summary'}
                style={company.isEmployeesBasic ? { color: '#348cf9' } : {}}
              >
                {formatNumber((+company.employees).toFixed(2))}
              </font>
              <span
                className="apostrophe-year"
                style={company.isEmployeesBasic ? { color: '#348cf9' } : {}}
              >
                &lsquo;
                {company.employeesYear?.toString?.()?.slice?.(-2) || PUNCTUATION.EMPTY_VALUE}
              </span>
              {!!company.isEmployeesBasic && (
                <Tooltip
                  anchorSelect={`#employees-company-details-general-tab-summary`}
                  multiline={true}
                  variant="dark"
                  place="bottom-center"
                  opacity={1}
                  content={<>Based on self-disclosure or estimate</>}
                />
              )}
            </>
          ) : (
            PUNCTUATION.EMPTY_VALUE
          )}
        </div>
      )}
    </div>
  );
};

SummaryEmployeesRow.propTypes = {
  company: PropTypes.object,
  canViewExtendedData: PropTypes.bool
};

export default SummaryEmployeesRow;
